<template>
    <TooliabaMessage :date="message.created_at">

        <MessageSection>
            <h6>Then rental is confirmed and payment is complete!</h6>
        </MessageSection>

        <MessageSection>
            <!-- at later date pass message.invoiceId into routerlink -->
            <router-link to="/invoice-detail" class="no-underline">
                <TooliabaButton>View Invoice</TooliabaButton>
            </router-link>
        </MessageSection>

        <RentalInfo :isRental="true" :rental="message.rental" />

    </TooliabaMessage>
</template>

<script>
import TooliabaMessage from '@/components/inbox/messagesCard/shared/TooliabaMessage.vue';
import MessageSection from '@/components/inbox/messagesCard/shared/MessageSection.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import RentalInfo from '@/components/inbox/messagesCard/shared/rentalInfo/RentalInfo.vue';

export default {
    components: {
        TooliabaMessage,
        MessageSection,
        TooliabaButton,
        RentalInfo
    },
    props: {
        message: {
            type: Object
        }
    }
};
</script>
